<rid-assignment-background />

<rid-klank-switch
  class="h-full"
  [assignments]="assignments()"
  [autoPresent]="autoPresent"
  (answered)="onAnswered($event)"
  (correct)="onCorrect()"
  (finished)="finish()"
/>
